export default __webpack_public_path__ + "images/cef5fa7008faa6e76ae626b031d3ec1c.png";